import produce from 'immer';
import {
  GET_AUTO_QUOTES_START,
  GET_AUTO_QUOTES_SUCCESS,
  GET_AUTO_QUOTES_FAILED,
  GET_AUTO_QUOTES_CUSTOMER_START,
  GET_AUTO_QUOTES_CUSTOMER_SUCCESS,
  GET_AUTO_QUOTES_CUSTOMER_FAILED,
  DOWNLOAD_AUTO_QUOTES_CUSTOMERS_START,
  DOWNLOAD_AUTO_QUOTES_CUSTOMERS_SUCCESS,
  DOWNLOAD_AUTO_QUOTES_CUSTOMERS_FAILED,
  CREATE_AUTO_QUOTE_START,
  CREATE_AUTO_QUOTE_SUCCESS,
  CREATE_AUTO_QUOTE_FAILED,
  GET_AUTO_QUOTES_SCHEDULES_START,
  GET_AUTO_QUOTES_SCHEDULES_SUCCESS,
  GET_AUTO_QUOTES_SCHEDULES_FAILED,
  EDIT_AUTO_QUOTE_SCHEDULE_START,
  EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS,
  EDIT_AUTO_QUOTE_SCHEDULE_FAILED,
  DELETE_AUTO_QUOTE_SCHEDULE_START,
  DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS,
  DELETE_AUTO_QUOTE_SCHEDULE_FAILED,

  SET_SELECTED_AUTO_QUOTE,
  SET_AUTO_QUOTE_ITEMS
} from '../actions/automated_quotes';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  autoQuotes: [],
  autoQuotesCustomersList: [],
  autoQuoteSchedules: [],
  automatedQuote: [],
  activeCampaignMeta: [],
  autoQuoteCustomersTotal: null,
  selectedAutoQuote: null,
  autoQuoteItems: null,
  autoQuotesLoading: false,
  autoQuotesCustomersListLoading: false,
  isDownloadAutoQuotesCustomersReport: false,
  createAutoQuoteLoading: false,
  autoQuotesSchedulesListLoading: false,
};

const formReducer = produce((state: IAutomatedQuotesState = initialState, action) => {
  switch (action.type) {
    case GET_AUTO_QUOTES_START: {
      state.autoQuotesLoading = true;
      break;
    }

    case GET_AUTO_QUOTES_SUCCESS: {
      const { customerRules } = action.data.data;
      state.autoQuotes = customerRules;
      state.autoQuotesLoading = false;
      break;
    }

    case GET_AUTO_QUOTES_FAILED: {
      state.autoQuotesLoading = false;
      break;
    }

    case GET_AUTO_QUOTES_CUSTOMER_START: {
      state.autoQuotesCustomersListLoading = true;
      break;
    }

    case GET_AUTO_QUOTES_CUSTOMER_SUCCESS: {
      const { resultCustomerRules, resultCustomerRulesTotal } = action.data.data;
      state.autoQuoteCustomersTotal = resultCustomerRulesTotal;
      state.autoQuotesCustomersList = resultCustomerRules;
      state.autoQuotesCustomersListLoading = false;
      break;
    }

    case GET_AUTO_QUOTES_CUSTOMER_FAILED: {
      state.autoQuotesCustomersListLoading = false;
      break;
    }

    case DOWNLOAD_AUTO_QUOTES_CUSTOMERS_START: {
      state.isDownloadAutoQuotesCustomersReport = true;
      break;
    }

    case DOWNLOAD_AUTO_QUOTES_CUSTOMERS_SUCCESS: {
      state.isDownloadAutoQuotesCustomersReport = false;
      break;
    }

    case DOWNLOAD_AUTO_QUOTES_CUSTOMERS_FAILED: {
      state.isDownloadAutoQuotesCustomersReport = false;
      break;
    }

    case CREATE_AUTO_QUOTE_START: {
      state.createAutoQuoteLoading = true;
      break;
    }

    case CREATE_AUTO_QUOTE_SUCCESS: {
      const { data } = action;
      state.automatedQuote = data;
      state.autoQuoteSchedules = [data, ...state.autoQuoteSchedules];
      state.createAutoQuoteLoading = false;
      break;
    }

    case CREATE_AUTO_QUOTE_FAILED: {
      state.createAutoQuoteLoading = false;
      break;
    }

    case GET_AUTO_QUOTES_SCHEDULES_START: {
      state.autoQuotesSchedulesListLoading = true;
      break;
    }

    case GET_AUTO_QUOTES_SCHEDULES_SUCCESS: {
      const { data } = action;
      state.autoQuoteSchedules = data;
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case GET_AUTO_QUOTES_SCHEDULES_FAILED: {
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case EDIT_AUTO_QUOTE_SCHEDULE_START: {
      state.autoQuotesSchedulesListLoading = true;
      break;
    }

    case EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS: {
      const { data } = action;
      console.log(data);
      state.autoQuoteSchedules = state.autoQuoteSchedules.map((schedule) => schedule._id === data._id ? data : schedule);
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case EDIT_AUTO_QUOTE_SCHEDULE_FAILED: {
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case DELETE_AUTO_QUOTE_SCHEDULE_START: {
      state.autoQuotesSchedulesListLoading = true;
      break;
    }

    case DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS: {
      const { id } = action;
      state.autoQuoteSchedules = state.autoQuoteSchedules.filter((schedule) => schedule._id != id);
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case DELETE_AUTO_QUOTE_SCHEDULE_FAILED: {
      state.autoQuotesSchedulesListLoading = false;
      break;
    }

    case SET_SELECTED_AUTO_QUOTE: {
      const { data } = action;
      state.selectedAutoQuote = data;
      break;
    }

    case SET_AUTO_QUOTE_ITEMS: {
      const { items } = action;
      state.autoQuoteItems = items;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.autoQuotes = initialState.autoQuotes;
      state.autoQuotesCustomersList = initialState.autoQuotesCustomersList;
      state.autoQuoteSchedules = initialState.autoQuoteSchedules;
      state.automatedQuote = initialState.automatedQuote;
      state.activeCampaignMeta = initialState.activeCampaignMeta;
      state.autoQuoteCustomersTotal = initialState.autoQuoteCustomersTotal;
      state.selectedAutoQuote = initialState.selectedAutoQuote;
      state.autoQuoteItems = initialState.autoQuoteItems;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
